import { useTranslation } from "react-i18next";
import useApi from "../../../utils/api";
import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { useProfile } from "../context";
import { getErrorMessage } from "../../../utils/helpers/errors";

export const usePBJApi = () => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [totalItems, setTotalItems] = useState();
    const [loading, setLoading] = useState(false);

    const { authGet, authPost, authPut, authDelete } = useApi();
    const { user, isSelf } = useProfile();

    const fetch = useCallback(async (params, { controller }) => {
        const url = isSelf ? "/profile/pbj-code" : `/users/${user?.id}/pbj-code`;
        setLoading(true)
        try {
            if(user?.id) {
                const response = await authGet(url, {
                    params,
                    signal: controller.signal
                });
                if (response) {
                    setData(response?.result);
                    setTotalItems(response?.totalItems);
                }
            }
        } catch (error) {
            getErrorMessage(error, t);
        } finally {
            setLoading(false)
        }
    }, [authGet, isSelf, user?.id, t]);

    const post = useCallback(
        async (data, close) => {
            const url = isSelf ? "/profile/pbj-code" : `/users/${user?.id}/pbj-code`
            setLoading(true);
            try {
                const response = await authPost(url, {
                    data,
                });
                if (response) {
                    toast.success(t("resource-created"));
                    setData((prev) => [...prev, response]);
                    setTotalItems((prev) => (prev || 0) + 1);
                    close();
                }
            } catch (error) {
                getErrorMessage(error, t);
            } finally {
                setLoading(false);
            }
        },
        [isSelf, user?.id, authPost, t]
    );

    const edit = useCallback(
        async (id, data, close) => {
            const url = isSelf ? `/profile/pbj-code/${id}` : `/users/${user?.id}/pbj-code/${id}`
            setLoading(true);
            try {
                const response = await authPut(url, {
                    data,
                });
                if (response) {
                    toast.success(t("resource-updated"));
                    setData((prev) => prev.map((item) => (item.id === id ? response : item)));
                    close();
                }
            } catch (error) {
                getErrorMessage(error, t);
            } finally {
                setLoading(false);
            }
        },
        [authPut, user?.id, fetch, t]
    );

    const deletePbj = useCallback(
        async (id) => {
            const url = isSelf ? `/profile/pbj-code/${id}` : `/users/${user?.id}/pbj-code/${id}`
            try {
                await authDelete(url);
                toast.success(t("resource-deleted"));
                setData((prev) => prev.filter((item) =>  item.id !== id))
                setTotalItems((prev) => prev - 1);
            } catch (error) {
                getErrorMessage(error, t);
            }
        },
        [authDelete, user?.id, fetch, t]
    );

    return {
        fetch,
        post,
        edit,
        deletePbj,
        totalItems,
        data,
        loading,
    };
};